import { HttpError } from '@rossum/api-client/errors';

export const httpErrorPreprocessor = (value: unknown): unknown => {
  if (value instanceof HttpError) {
    return value.data;
  }

  return {};
};
